/* eslint-disable react/prop-types */

/* eslint-disable prettier/prettier */
import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.5 16.8c-.67 0-1.214-.537-1.214-1.2 0-.663.543-1.2 1.214-1.2.67 0 1.214.537 1.214 1.2 0 .663-.543 1.2-1.214 1.2m0-6c-2.678 0-4.857 2.153-4.857 4.8s2.179 4.8 4.857 4.8c2.678 0 4.857-2.153 4.857-4.8s-2.179-4.8-4.857-4.8M12.5 6.6c.67 0 1.214-.538 1.214-1.2 0-.662-.544-1.2-1.214-1.2-.67 0-1.214.538-1.214 1.2 0 .662.544 1.2 1.214 1.2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5 21.6c-3.353 0-6.071-2.686-6.071-6s2.718-6 6.071-6c3.353 0 6.071 2.686 6.071 6s-2.718 6-6.071 6m0-18.6c1.341 0 2.429 1.075 2.429 2.4S13.84 7.8 12.5 7.8c-1.341 0-2.429-1.075-2.429-2.4S11.16 3 12.5 3m6.071-3H6.43C5.087 0 4 1.075 4 2.4v19.2C4 22.925 5.087 24 6.429 24H18.57C19.913 24 21 22.925 21 21.6V2.4C21 1.075 19.913 0 18.571 0"
}))), 'CategoryEA');